module.exports = __webpack_public_path__ + "static/media/social-share-facebook.c75ee37b.svg";